const route = [
    {//作业详情
        path: '/taskdetial/:sid/:classid/:taskid/:taskType/:testType',
        component: function (resolve) {
            require(['VIEWS/math/inspect/taskdetial.vue'], resolve);
        }
    },
    {//试题错误详情
        path: '/errorRate/:sid/:classid/:taskid/:qnumber',
        component: function (resolve) {
            require(['VIEWS/math/inspect/errorRate.vue'], resolve);
        }
    },
    {//试题错误详情-速算
        path: '/errorRate/quick/:sid/:classid/:taskid/:qnumber',
        component: function (resolve) {
            require(['VIEWS/math/inspect/errorRateQuick.vue'], resolve);
        }
    },
    {//作业预览-作业
        path: '/preview/task/:sid/:taskid/:type',
        component: function (resolve) {
            require(['VIEWS/math/inspect/taskPreview.vue'], resolve);
        }
    },
    {//活动作业预览-作业
        path: '/preview/task/:sid/:taskid',
        component: function (resolve) {
            require(['VIEWS/math/inspect/taskPreview.vue'], resolve);
        }
    },
    {//作业预览-知识点视频
        path: '/preview/video/:taskid',
        component: function (resolve) {
            require(['VIEWS/math/inspect/videoPreview.vue'], resolve);
        }
    },
    {//个人作业详情
        path: '/mytask/:sid/:classid/:taskid/:user_id/:username',
        component: function (resolve) {
            require(['VIEWS/math/inspect/mytask.vue'], resolve);
        }
    },
    {//个人作业详情-速算
        path: '/mytask/quick/:sid/:classid/:taskid/:user_id/:username',
        component: function (resolve) {
            require(['VIEWS/math/inspect/mytaskQuick.vue'], resolve);
        }
    },
    {//学情分析分享页面
        path: '/sx/sharetoparent/:uid/:taskId/:taskType/:testType',
        component: function (resolve) {
            require(['VIEWS/math/inspect/shareToParent.vue'], resolve);
        }
    },
    {//发作业页面  // type:1,2,3,4,5
        // 小学# 1:知识点 2 同步习题 3 单元复习 4 速算 5 高频错题
        // 初中# 2 同步习题 3 单元复习  5 高频错题
        path: '/sx/release/:type',
        component: function (resolve) {
            require(['VIEWS/math/module/release.vue'], resolve);
        }
    },
];
export default route
